import isFunction from 'lodash/isFunction';
import { matchPath } from 'react-router-dom';
import { enabledSteps } from 'src/utils/capabilities';
import getMergedByPropertySteps from './stepsMerger';
import mergeCustomWithBaseSteps from './mergeCustomWithBaseSteps';

class StepsManager {
  constructor(steps) {
    this.steps = mergeCustomWithBaseSteps({ ...steps });
  }

  getStepIndex = (stepUrl, isOnboarding) => {
    let mergedSteps = getMergedByPropertySteps(this.steps, {
      mergeProp: 'menu',
    });
    if (isOnboarding && enabledSteps) {
      mergedSteps = mergedSteps.filter(step =>
        enabledSteps.includes(step.menu),
      );
    }
    const index = mergedSteps.findIndex(step => {
      const { current, next } = step;
      return (
        matchPath(stepUrl, {
          path: current || '',
          exact: true,
        }) ||
        matchPath(stepUrl, {
          path: typeof next === 'string' ? next : '',
          exact: true,
        })
      );
    });
    return index;
  };

  getStepByIndex = (index, isOnboarding) => {
    let mergedSteps = getMergedByPropertySteps(this.steps, {
      mergeProp: 'menu',
    });
    if (isOnboarding && enabledSteps) {
      mergedSteps = mergedSteps.filter(step =>
        enabledSteps.includes(step.menu),
      );
    }
    return mergedSteps[index];
  };

  getStep = stepUrl => {
    const key = Object.keys(this.steps).find(stepPath => {
      return matchPath(stepUrl, {
        path: stepPath,
        exact: true,
      });
    });
    return this.steps[key];
  };

  getNextUrl = (currentUrl, state) => {
    let { next } = this.getStep(currentUrl);
    if (isFunction(next)) {
      next = next(state);
    }
    return next;
  };

  getBackUrl = (currentUrl, state) => {
    let { back } = this.getStep(currentUrl);

    if (isFunction(back)) {
      back = back(state);
    }
    return back;
  };

  getLifecycleStep = currentPath => {
    const step = this.getStepIndex(currentPath);
    return step;
  };

  isLifecycleAvailable = currentPath => this.getLifecycleStep(currentPath) >= 0;

  getLifecycleStepList = isOnboarding => {
    const mergedSteps = getMergedByPropertySteps(this.steps, {
      mergeProp: 'menu',
    }).map(step => step.menu);
    if (isOnboarding && enabledSteps) {
      return mergedSteps.filter(step => enabledSteps.includes(step));
    }
    return mergedSteps;
  };

  getMaxLifecycleStep = (agency, isOnboarding, agent) => {
    const allLifecycleSteps = this.getLifecycleStepList(isOnboarding);
    const lifecycleMapping = this.getLifecycleMapping(agency, agent);
    return (
      allLifecycleSteps.reverse().find(step => {
        return isFunction(lifecycleMapping[step])
          ? lifecycleMapping[step]()
          : null;
      }) || ''
    );
  };

  isHiddenNavigation = currentPath =>
    !!this.getStep(currentPath)?.isHiddenNavigation;

  getLifecycleMapping = () => {
    throw new Error('You must implement getLifecycleMapping method');
  };
}
export default StepsManager;
